import { Choose } from './Choose/Choose'
import Footer from './Footer'
import { Frequency } from './Frequency/Frequency'
import { Sender } from './Sender/Sender'

export const Step3 = () => {
  return (
    <>
      <Sender />
      <Choose />
      <Frequency />
      <Footer />
    </>
  )
}
